__turbopack_context__.v({
  "arrowTopBtn": "TestimonialsSection-module__g8XAva__arrowTopBtn",
  "arrowsTop": "TestimonialsSection-module__g8XAva__arrowsTop",
  "avatar": "TestimonialsSection-module__g8XAva__avatar",
  "bottomLine": "TestimonialsSection-module__g8XAva__bottomLine",
  "card": "TestimonialsSection-module__g8XAva__card",
  "counterRow": "TestimonialsSection-module__g8XAva__counterRow",
  "currentNum": "TestimonialsSection-module__g8XAva__currentNum",
  "desc": "TestimonialsSection-module__g8XAva__desc",
  "headerContainer": "TestimonialsSection-module__g8XAva__headerContainer",
  "headerTitle": "TestimonialsSection-module__g8XAva__headerTitle",
  "mainTitle": "TestimonialsSection-module__g8XAva__mainTitle",
  "rightSideWrapper": "TestimonialsSection-module__g8XAva__rightSideWrapper",
  "rightText": "TestimonialsSection-module__g8XAva__rightText",
  "stars": "TestimonialsSection-module__g8XAva__stars",
  "subTitle": "TestimonialsSection-module__g8XAva__subTitle",
  "topBar": "TestimonialsSection-module__g8XAva__topBar",
  "total": "TestimonialsSection-module__g8XAva__total",
  "userName": "TestimonialsSection-module__g8XAva__userName",
  "userRole": "TestimonialsSection-module__g8XAva__userRole",
  "userRow": "TestimonialsSection-module__g8XAva__userRow",
  "wrapper": "TestimonialsSection-module__g8XAva__wrapper",
});
